@if (item().type === NavBarItemType.ACTION) {
	@if (isMobileNav()) {
		<a class="nav-link df-nav-action" role="button" (click)="action.emit(item().action ?? '')">
			<i class="bi bi-sliders me-2"></i>{{ item().label }}
		</a>
	}
} @else if (isMobileNav() && item().type === NavBarItemType.DROPDOWN) {
	<div class="df-panel-group">{{ item().label }}</div>
	@for (child of item().children; track $index) {
		<a class="nav-link df-panel-child" routerLinkActive="is-active" [routerLink]="child.route">{{
			child.label
		}}</a>
	}
} @else if (item().type === NavBarItemType.DROPDOWN) {
	<div
		class="order-lg-4 fs-6 d-flex align-items-center justify-content-center fw-semibold dropdown"
	>
		<a
			class="nav-link dropdown-toggle"
			[class.is-active]="isActive()"
			data-bs-toggle="dropdown"
			href="#"
			role="button"
			aria-expanded="false"
			>{{ item().label }}</a
		>
		<ul class="dropdown-menu dropdown-menu-end mx-auto">
			@for (child of item().children; track $index) {
				<li>
					<a
						class="dropdown-item"
						routerLinkActive="active"
						[routerLink]="child.route"
						>{{ child.label }}</a
					>
				</li>
			}
		</ul>
	</div>
} @else if (item().type == NavBarItemType.BASE) {
	<div
		class="order-lg-4 fs-6 d-flex align-items-center justify-content-center fw-semibold dropdown"
	>
		<a class="nav-link" [class.is-active]="isActive()" [routerLink]="item().route" role="button">{{
			item().label
		}}</a>
	</div>
}
